import { typeCreatorV2 } from 'redux/utils/common';

export const SET_CLIENTS_MINI_PROFILES: string = typeCreatorV2(
  'SendmailReducer',
  'SetClientMiniProfile'
);

export const SEND_EMAIL_PRODUCT: string = typeCreatorV2(
  'SendmailReducer',
  'SendEmail'
);

export const SEND_EMAIL_ADVANCE_PRODUCT: string = typeCreatorV2(
  'SendmailReducer',
  'SendEmailAdvance'
);

export const SET_PRODUCT_DOCUMENT: string = typeCreatorV2(
  'SendmailReducer',
  'SetProductDocument'
);

export const RESET_DOCUMENT: string = typeCreatorV2(
  'SendmailReducer',
  'ResetDocument'
);
